import { IconActionHistory, IconButton, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type ExpenseApprovalLog } from '@webapp/modules/expense/entities/ExpenseApprovalLog'
import messages from './messages'
import { useExpenseApprovalHistoryPresenter } from './useExpenseApprovalHistoryPresenter'
import { WithApprovalHistoryPopover } from '../../views/ApprovalHistory/WithApprovalHistoryPopover'

export interface IExpenseApprovalHistoryPresenterProps {
  logs: ExpenseApprovalLog[]
}

export const ExpenseApprovalHistoryPresenter = ({
  logs,
}: IExpenseApprovalHistoryPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { approvalHistory },
  } = useExpenseApprovalHistoryPresenter({ logs })

  return (
    <WithApprovalHistoryPopover approvalHistory={approvalHistory}>
      <WithTooltip
        title={intl.formatMessage(messages.buttonLabel)}
        placement='bottom'
      >
        <span>
          <IconButton
            iconComponent={<IconActionHistory />}
            aria-label={intl.formatMessage(messages.buttonLabel)}
          />
        </span>
      </WithTooltip>
    </WithApprovalHistoryPopover>
  )
}

ExpenseApprovalHistoryPresenter.displayName = 'ExpenseApprovalHistoryPresenter'
